<p>
  За да публикувате нова обява, натиснете бутона <strong>„Добави нова обява“</strong> от началната страница или от
  горната навигационна лента. Ще бъдете пренасочени към процеса по създаване на обява, който се състои от
  <strong>четири последователни стъпки</strong>.
</p>
<hr class="my-3">
<h6>Стъпка 1: Основна информация</h6>
<p class="mb-1">
  На първата стъпка е необходимо да попълните следните полета:
</p>
<ul class="mb-3">
  <li><strong>Категория и подкатегория*</strong> – изберете подходяща категория и подкатегория, към която принадлежи
    артикулът.
  </li>
  <li><strong>Допълнителни спецификации</strong> – налични в зависимост от избраната категория и подкатегория (напр.
    година, сертификат, държава и др.).
  </li>
  <li><strong>Заглавие*</strong> – кратко и ясно, до 100 символа.</li>
  <li><strong>Идентификатор</strong> – Това поле е видимо само за вас. Можете да го използвате за въвеждане на уникален
    идентификатор за всеки артикул. Например при продажба на множество артикули може да зададете номера като C-001,
    C-002, което ще улесни тяхното намиране при обработка на поръчки.
  </li>
  <li><strong>Описание</strong> – до 2000 символа (препоръчително).</li>
  <li><strong>Снимки*</strong> – до 10 снимки, поне една е задължителна. Първата се използва като основна.</li>
</ul>
<hr class="my-3">
<h6 class="mt-3">Стъпка 2: Вид и параметри на обявата</h6>
<p class="mb-1">
  В тази стъпка трябва да изберете какъв вид обява ще публикувате – с фиксирана цена или под формата на търг
  (аукцион). Всеки вид има свои специфични изисквания и допълнителни опции, които ви дават гъвкавост при определяне
  на условията за продажба.
</p>
<ul class="mb-3">
  <li class="mb-2">
    <strong>Обява с фиксирана цена</strong> – Купувачите могат да закупят артикула незабавно на посочената от вас цена.
    <ul>
      <li>Продавачът може да редактира цената до момента на сключване на сделка.</li>
      <li>След сключване на сделка, цената не може да бъде променяна.</li>
      <li>При избор на този вид обява, се изисква да попълните:
        <ul>
          <li>
            <strong>Фиксирана цена*</strong> – задължително поле. Посочете точната сума, на която желаете да продадете
            артикула.
          </li>
          <li>
            <strong>Приемам ценови предложения</strong> – Активирайки тази опция, позволявате на купувачите да ви
            изпращат оферти, различни от фиксираната цена.
            <ul>
              <li>Всяко предложение е валидно <strong>72 часа</strong>.</li>
              <li>В този срок може да:
                <ul>
                  <li>Приемете предложението;</li>
                  <li>Откажете предложението;</li>
                  <li>Изпратите контрапредложение.</li>
                </ul>
              </li>
              <li>Ако не реагирате в рамките на 72 часа, предложението ще бъде анулирано автоматично.</li>
              <li>Тази опция е подходяща, ако сте отворени за договаряне или желаете да ускорите продажбата.</li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>
  </li>
  <li class="mb-2">
    <strong>Обява с наддаване (аукцион)</strong> – Артикулът се предлага чрез търг, при който крайната цена се определя
    от най-високата оферта.
    <ul>
      <li>Наддаването продължава до зададената крайна дата и час.</li>
      <li>След стартиране, <strong>началната цена</strong> и <strong>минималната стъпка</strong> не могат да се
        редактират.
      </li>
      <li>При избор на този вид обява, се изисква да попълните:
        <ul>
          <li><strong>Начална цена*</strong> – минималната стойност, от която започва търгът.</li>
          <li><strong>Минимална стъпка*</strong> – с колко лева трябва да се надхвърли текущата оферта.</li>
        </ul>
      </li>
      <li>Допълнителни (незадължителни) опции:
        <ul>
          <li>
            <strong>Купи сега цена</strong> – Позволява артикулът да бъде закупен веднага, без наддаване. Скрива се
            автоматично след първо наддаване или достигане на запазена цена.
          </li>
          <li>
            <strong>Запазена цена</strong> – Минималната цена, под която не сте съгласни да продадете. Видима е само за
            вас.
          </li>
          <li>
            <strong>Удължаване на аукциона</strong> – Удължава времето с няколко минути, ако в последните секунди бъде
            подадена нова оферта. Това предпазва от последно-моментно наддаване и дава шанс за реакция.
          </li>
        </ul>
      </li>
    </ul>
  </li>
  <li>
    <strong>Автоматично обновяване след завършване без продажба</strong> – Може да активирате тази опция, независимо от
    избрания вид обява. При неуспешна продажба в края на периода, обявата ще бъде автоматично подновена с първоначалните
    параметри.
  </li>
  <li>
    <strong>Начална и крайна дата/час*</strong> – Определяте времевия период, в който обявата ще бъде активна и видима
    за останалите потребители. След публикуване, тези параметри <strong>не подлежат на редакция</strong>, затова ги
    прегледайте внимателно преди потвърждение.
  </li>
</ul>
<hr class="my-3">
<h6 class="mt-3">Стъпка 3: Местоположение и логистика</h6>
<p class="mb-1">
  В тази стъпка се посочват адреса от които се изпраща артикула и начините на даставка и плащане.
</p>
<ul class="mb-3">
  <li>
    <strong>Област, Община и Населено място*</strong> – Тези полета са задължителни, освен ако вече сте задали адрес
    по подразбиране от настройките на профила си.
  </li>
  <li>
    <strong>Запази като адрес по подразбиране</strong> – Ако публикувате обяви често и използвате едно и също
    местоположение, може да маркирате тази опция. При следващи обяви адресът ще се попълва автоматично.
  </li>
  <li>
    <strong>Начин на плащане</strong> – Изберете един или повече предпочитани методи, които купувачът може да използва.
  </li>
  <li>
    <strong>Начин на доставка</strong> – Изберете налични опции според това как предпочитате да изпратите артикула.
  </li>
  <li>
    <strong>Допълнителна информация (по желание)</strong> – Можете да добавите текст в свободна форма в две полета:
    <ul>
      <li>Допълнително информация за плащането и доставката – полезно при специални условия, забележки или инструкции.
      </li>
      <li>Допълнителна информация за артикула – ако има нещо, което не сте включили в описанието (например произход,
        редки
        характеристики и т.н.).
      </li>
    </ul>
  </li>
</ul>
<hr class="my-3">
<h6>Стъпка 4: Преглед и потвърждение</h6>
<p>
  Ще видите визуализация на обявата преди публикуване. Можете да редактирате всички данни, ако е необходимо. Натиснете
  бутона <strong>„Запази“</strong>, за да публикувате обявата.
</p>

<div class="alert alert-primary">
  <strong>Съвет:</strong> Подгответе добра снимка, кратко, но ясно заглавие и пълно описание. Това ще увеличи шанса ви
  за бърза и успешна продажба.
</div>

<h6 class="mt-3">Създаване на подобна обява</h6>
<p>
  Независимо от статуса на една обява, може лесно да създадете нова, подобна обява на нейна база. Това е особено
  удобно, ако предлагате артикули със сходни характеристики или ако имате налични допълнителни бройки от вече публикуван
  продукт.
</p>
<p>
  За да използвате тази функция, отворете <strong>страницата на съответната обява</strong> или навигирайте до
  <strong>„Профил“ → „Моите обяви“</strong>, натиснете бутона с <strong>три точки (⋮)</strong> до желаната обява и изберете
  <strong>„Създаване на подобна обява“</strong>.
</p>
<p class="m-0">
  Ще се зареди формата за създаване на обява с предварително попълнени данни от избраната обява – като заглавие,
  описание, ценови параметри, категория, методи за доставка и други. Единственото, което трябва да добавите ръчно, са
  <strong>снимките</strong> и <strong>новата крайна дата и час</strong> на обявата.
</p>
